import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { AddWorkNoteCommand } from './add-work-note.command';
import { AddWorkNoteResult } from './add-work-note.result';

/**
 * Add work note use case.
 * Adds a new work note to a case.
 */
@Injectable({ providedIn: 'root' })
export class AddWorkNoteUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(command: AddWorkNoteCommand): Observable<AddWorkNoteResult> {
    this._state.setAddingWorkNote(true);
    this._state.setErrorWorkNotes(null);

    return this._repository.addWorkNote(command.caseId, command.body, command.attachments).pipe(
      tap(() => {
        this._state.setAddingWorkNote(false);
      }),
      map((response) => ({ workNoteId: response.id })),
      catchError((error) => {
        this._state.setErrorWorkNotes(error.message || 'Failed to add work note');
        this._state.setAddingWorkNote(false);
        return throwError(() => error);
      })
    );
  }
}
